module.exports = __webpack_public_path__ + "static/media/editMemberRoster.svg";